import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { applyTheme } from '../lib/themes';

interface ThemeContextValue {
  theme: string;
  setTheme: (theme: string) => Promise<void>;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: 'default',
  setTheme: async () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setThemeState] = useState<string>(() => {
    return localStorage.getItem('discgo-theme') || 'default';
  });

  // Themes hidden pre-launch — always force default regardless of localStorage/DB
  useEffect(() => {
    applyTheme('default');
  }, []);

  const setTheme = async (newTheme: string) => {
    setThemeState(newTheme);
    localStorage.setItem('discgo-theme', newTheme);
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      await supabase.from('profiles').update({ theme: newTheme }).eq('id', user.id);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
